module.exports = __webpack_public_path__ + "static/media/urbansgem_logo.bfc22a0f.png";